export {};
//# sourceMappingURL=IDiagnosticLogger.js.map